module.exports = __webpack_public_path__ + "static/media/featureSmart_hero.1e9ac79b.png";